export default __webpack_public_path__ + "static/media/settings.52308b75.jpg";